<template>
  <div class="context">
    <div class="cardheard">
      <div>
        <el-input
          clearable
          style="width: 200px; margin-right: 20px"
          placeholder="请输入房间名称"
          v-model="req.query.productName"/>
      </div>

      <div>
        <el-select
          style="width: 200px; margin-right: 20px"
          v-model="req.query.productTypeId"
          placeholder="请选择分类"
        >
          <el-option
            v-for="item in options2"
            :key="item.id"
            :label="item.productTypeName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <el-button
        type="primary"
        @click="selectByQuery()"
        icon="el-icon-search"
      ></el-button>
      <el-button @click="clear">清空</el-button>
      <el-button @click="brandShow = true">房间类别管理</el-button>
      <el-button @click="productShow = true">添加房间</el-button>
    </div>

    <template>
      <el-table :data="homes" style="width: 100%" height="80%">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>

        <el-table-column label="房间图片">
          <template slot-scope="scope">
            <div class="demo-image__preview">
              <!-- <el-image 
              :src="scope.row.homePic"
            </el-image> -->
              <el-image
                style="width: 140px; height: 100px"
                :src="scope.row.homePic"
                :fit="fit"
              ></el-image>
              <!-- <img :src="scope.row.homePic" style="width:140px;height:100px" /> -->
            </div>
          </template>
        </el-table-column>

        <el-table-column label="房间号">
          <template slot-scope="scope">
            <span>{{ scope.row.homeNum }}</span>
          </template>
        </el-table-column>

        <el-table-column label="房间名称">
          <template slot-scope="scope">
            <span>{{ scope.row.homeName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="类别">
          <template slot-scope="scope">
            <span>{{ scope.row.homeTypeName }}</span>
          </template>
        </el-table-column>

        <el-table-column label="价格">
          <template slot-scope="scope">
            <span>{{ scope.row.homePrice }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link icon="el-icon-s-open" @click="copyHome(scope.row)"
              >复制改房型</el-link
            >
            <!-- <el-button type="text" @click="copyHome(scope.row)" size="small">复制改房型</el-button> -->
            <!-- <el-button type="text" @click="updateProduct(scope.row)" size="small">编辑</el-button> -->
            <el-link icon="el-icon-edit" @click="updateProduct(scope.row)"
              >编辑</el-link
            >
            <el-link icon="el-icon-delete-solid" @click="delfirm(scope.row)"
              >删除</el-link
            >
            <!-- <el-button type="text" @click="delfirm(scope.row)" size="small">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </template>

    <div v-if="brandShow">
      <brandAdmin :dialogShow="brandShow" @brandShowChange="brandShowChange" />
    </div>

    <div v-if="typeShow">
      <productTypeAdmin
        :dialogShow="typeShow"
        @productTypeShowChange="productTypeShowChange"
      />
    </div>

    <div v-if="productShow">
      <productUpdateOrAdd
        :dialogShow="productShow"
        ref="updateProduct"
        @action="productShowAction()"
        @pushdata="pushdata"
        @productShowChange="productShowChange"
      />
    </div>

    <div class="block">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="1000"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import brandAdmin from "@/components/brandAdmin";
import productTypeAdmin from "@/components/productTypeAdmin";
import productUpdateOrAdd from "@/components/productUpdateOrAdd";
export default {
  name: "product",
  components: {
    brandAdmin,
    productTypeAdmin,
    productUpdateOrAdd,
  },
  data() {
    return {
      req: {
        pageIndex: 0,
        pageCount: 10,
        query: {
          homeName: "",
          homeTypeId: "",
        },
      },
      productShow: false,
      typeShow: false,
      brandShow: false,
      homes: [],
      options1: [],
      options2: [],
    };
  },

  created() {
    var that = this;
    console.log("Vue 初始化完成 created");
    this.pushdata();
    this.selectType();
  },

  methods: {
    selectByQuery() {
      this.pushdata();
    },
    updateProduct(row) {
      (this.productShow = true),
        setTimeout(() => {
          this.$refs["updateProduct"].init(row.id); //用$refs赋值调用子组件的init方法
        }, 500);
    },

    copyHome(row) {
      this.$confirm("复制该房间, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.copyHomeDelfirm(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    copyHomeDelfirm(row) {
      var that = this;
      this.$axios
        .get("/api2/business/copyHome/" + row.id, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.pushdata();
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },

    delfirm(row) {
      this.$confirm("此操作删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del(row);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    brandShowChange(visible) {
      this.brandShow = visible;
    },
    productTypeShowChange(visible) {
      this.typeShow = visible;
    },
    productShowChange(visible) {
      this.productShow = visible;
    },

    change() {
      this.$forceUpdate();
    },

    clear() {
      this.req.query.productTypeId = "";
      this.req.query.brandId = "";
      this.req.query.productName = "";
      this.reset();
      this.pushdata();
    },

    selectType() {
      var that = this;
      var req = {
        pageIndex: 0,
        pageCount: 100,
        query: {
          sysUserId: "1",
          id: "",
        },
      };
      req.sysUserId = this.$store.state.user.user.id;
      this.$axios
        .post("/api2/business/getHomeType", req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.options1 = response.data.data;
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },

    next(a) {
      console.log(a);
    },
    reset() {
      this.req.pageIndex = 0;
      this.req.pageCount = 10;
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);

      if (val != 1) {
        var statcount = (val - 1) * this.req.pageCount;
        this.req.pageIndex = statcount;
        console.log("当前开始index--" + statcount);
      } else {
        this.req.pageIndex = 0;
        console.log("当前开始index--" + statcount);
      }

      console.log(this.req);
      this.pushdata();
    },
    del(row) {
      var that = this;

      this.$axios
        .get("/api2/business/delHome/" + row.id, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: "success",
              message: "操作成功",
            });
            that.pushdata();
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
    pushdata() {
      var that = this;
      this.$axios
        .post("/api2/business/getHomeByPage", this.req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.homes = response.data.data;
            that.homes.forEach(function name(params) {
              if (params.fileList) {
                var arr = [];
                params.fileList.forEach(function (e) {
                  arr.push(e.url);
                });
                params.fileList = arr;
              }
            });
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },
  },
};
</script>

<style scoped>
.home {
  right: 0px;
  top: 150px;
  position: absolute;
}

.myheard {
  margin-left: 10px;
  display: flex;
}

.block {
  margin-top: 0px;
}
</style>
